import { createTheme } from '@mui/material'
import '@fontsource/be-vietnam-pro'

declare module '@mui/material/styles' {
  interface Palette {
    gray: Palette['primary']
  }

  interface PaletteOptions {
    gray: PaletteOptions['primary']
  }

  interface PaletteColor {
    semiTransparent?: string
  }

  interface SimplePaletteColorOptions {
    semiTransparent?: string
  }
}

declare module '@mui/material/IconButton' {
  interface IconButtonPropsColorOverrides {
    gray: true
  }
}

export const createEiduTheme = (primaryMain: string) =>
  createTheme({
    palette: {
      mode: 'light',
      primary: {
        main: primaryMain,
        contrastText: '#ffffff',
        semiTransparent: '#ede7faaa',
      },
      secondary: {
        main: '#f3c049',
      },
      gray: {
        main: '#808080',
      },
    },
    typography: {
      fontFamily: '"Be Vietnam Pro"',
    },
  })
